$shm_hitalama_map_back $mol_view
	event *
		^
		pointerdown? <=> event_pointerdown? null
		contextmenu? <=> event_contextmenu? null
	- plugins /
		<= Touch $mol_touch
			- allow_draw false
			- allow_pan <= allow_pan? true
			- pointer_center => cursor_position
			draw_start? <=> draw_start? null
			draw? <=> draw? null
			draw_end? <=> draw_end? null
